import * as React from 'react';
import { _t } from '@hip/translations';
export const CloseIcon = () => {
    const alt = _t('icons.close');
    return (React.createElement("svg", { role: "img", "aria-label": alt, width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": 'close-icon' },
        React.createElement("title", { id: 'close-icon' }, alt),
        React.createElement("path", { d: "M10.54 12l-4.246 4.245a1 1 0 0 0 0 1.414l.047.045a1 1 0 0 0 1.416 0L12 13.46l4.245 4.246a1 1 0 0 0 1.414 0l.045-.047a1 1 0 0 0 0-1.416L13.46 12l4.246-4.245a1 1 0 0 0 0-1.414l-.047-.045a1 1 0 0 0-1.416 0L12 10.54 7.755 6.293a1 1 0 0 0-1.414 0l-.045.047a1 1 0 0 0 0 1.415L10.54 12z" })));
};
